// Libraries
import React, { Component } from 'react'
import I18n from 'i18next'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get, defaultTo, isNil, isEmpty, map, orderBy, lowerCase } from 'lodash'
import {
  Empty,
  Card,
  Timeline,
  Tooltip,
  Button,
  message,
  Modal,
  Skeleton
} from 'antd'

// Resources
import { actions as eventActions } from 'Resources/EventResource'

const { confirm } = Modal

class EventsTab extends Component {
  static propTypes = {
    // DonnÃ©es de la vue
    scenario: PropTypes.object,
    title: PropTypes.string,

    // Fonction de refresh
    getScenarioData: PropTypes.func,

    // ContrÃ´le de la modal
    modal: PropTypes.object,

    // Actions d'API
    actions: PropTypes.object,

    // TÃ©moins d'activitÃ© API
    loading: PropTypes.bool,
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool
  }

  static defaultProps = {
    // DonnÃ©es de la vue
    scenario: {},

    // ContrÃ´le de la modal
    modal: {},

    // TÃ©moins d'activitÃ© API
    loading: false,
    isGathering: false,
    isUpdating: false
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  /**
   * Suppression d'un Ã©vÃ©nement
   */
  deleteEvent = event => {
    this.props.actions
      .deleteEvent(event)
      .then(() => {
        message.success(I18n.t('api.success.event.delete'))

        // RafraÃ®chissement de la liste des Ã©vÃ©nements du scÃ©nario
        this.props.getScenarioData()
      })
      .catch(() => {
        message.error(I18n.t('api.errors.event.delete'))
      })
  }

  /**
   * Demande de suppression d'un Ã©vÃ©nement
   */
  askDeleteEvent = event => {
    confirm({
      title: I18n.t('pages.scenario.modal.event.delete.single.title'),
      content: I18n.t('pages.scenario.modal.event.delete.single.content'),
      okText: I18n.t('pages.scenario.modal.event.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenario.modal.event.delete.single.cancelText'),
      onOk: () => {
        this.deleteEvent(event)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande de modification d'un Ã©vÃ©nement
   */
  askUpdateEvent = event => {
    const { modal } = this.props

    this.props.actions
      .getEvent(event)
      .then(modal.open)
      .catch(() => message.error(I18n.t('api.errors.event.get')))
  }

  getEventName = event =>
    defaultTo(
      get(event, 'name'),
      I18n.t(
        `pages.scenario.tabs.events.operation.${lowerCase(
          get(event, 'eventType')
        )}`,
        {
          operation: I18n.t(
            `pages.scenario.tabs.events.operation.${lowerCase(
              get(event, 'operation')
            )}`
          ),
          element: I18n.t(
            `pages.scenario.tabs.events.operation.element.${lowerCase(
              get(event, 'operationProperty')
            )}.${lowerCase(get(event, 'element'))}`
          )
        }
      )
    )

  /**
   * Rendu d'une ligne de d'information
   */
  renderEventDetailsRow = (event, { format, visible = true }, key) => {
    const { loading } = this.props

    return (
      visible && (
        <Skeleton
          key={key}
          className='drawer-layout-description-item-skeleton'
          paragraph={false}
          loading={loading}
        >
          <p className='drawer-layout-description-item'>
            {/* Nom de la ligne */}
            <span className='drawer-layout-description-item-name'>
              {I18n.t(`pages.scenario.tabs.events.rows.${key}.title`)}
            </span>

            {/* Valeur de la ligne */}
            <span className='drawer-layout-description-item-value'>
              {!isNil(format) ? format(get(event, key)) : get(event, key)}
            </span>
          </p>
        </Skeleton>
      )
    )
  }

  /**
   * Rendu d'un Ã©vÃ©nement
   */
  renderEvent = (event, index) => {
    const { scenario, loading, isGathering, isUpdating } = this.props

    const isLoading = loading || isGathering || isUpdating

    // PrÃ©paration des informations Ã  afficher
    const eventDetails = {
      // DÃ©bit
      flowValue: {
        visible: get(event, 'operationProperty') === 'FLOW',
        format: flowValue => `${defaultTo(flowValue, 0).toLocaleString()} mÂ³/h`
      },
      // Volume
      volumeValue: {
        visible: get(event, 'operationProperty') === 'VOLUME',
        format: volumeValue =>
          `${defaultTo(volumeValue, 0).toLocaleString()} mÂ³`
      },
      // Impact sur la cuvette
      affectsBasin: {
        visible:
          get(event, 'operationProperty') === 'FLOW' &&
          get(event, 'eventType') === 'BASIN',
        format: affectsBasin =>
          I18n.t(`pages.scenario.tabs.events.rows.affectsBasin.${affectsBasin}`)
      },
      // Impact sur les rÃ©servoirs
      affectsTank: {
        visible:
          get(event, 'operationProperty') === 'FLOW' &&
          get(event, 'eventType') === 'TANK',
        format: affectsTank =>
          I18n.t(`pages.scenario.tabs.events.rows.affectsTank.${affectsTank}`)
      },
      // DÃ©bit impactant la cuvette
      basinValue: {
        visible:
          get(event, 'affectsBasin') &&
          get(event, 'operationProperty') === 'FLOW' &&
          get(event, 'eventType') === 'BASIN',
        format: volume => `${defaultTo(volume, 0).toLocaleString()} mÂ³/h`
      }
    }

    return (
      <Timeline.Item
        className='scenario-events-timeline-item'
        key={index}
        color={
          get(event, 'element') === 'WATER'
            ? 'blue'
            : get(event, 'element') === 'MIX'
            ? 'purple'
            : 'grey'
        }
      >
        {/* Titre de l'Ã©vÃ©nement */}
        <h3 className='scenario-events-timeline-item-title'>
          {this.getEventName(event)}
        </h3>

        {/* DÃ©tails */}
        {get(event, 'eventType') !== 'COMMENT' && (
          <div className='scenario-events-timeline-item-details'>
            {map(eventDetails, (details, index) =>
              this.renderEventDetailsRow(event, details, index)
            )}
          </div>
        )}

        {/* Commentaire */}
        {!isNil(get(event, 'comment')) && (
          <p className='timeline-item-comment'>{get(event, 'comment')}</p>
        )}

        {/* Dates */}
        <p className='scenario-events-timeline-item-dates'>
          {/* Date de crÃ©ation de l'Ã©vÃ©nement */}
          {moment(get(event, 'startDate')).isValid() && (
            <Tooltip
              placement='left'
              title={moment(get(event, 'startDate')).calendar()}
            >
              <span className='scenario-events-timeline-item-date scenario-events-timeline-item-date-started'>
                {I18n.t('pages.scenario.tabs.events.dates.start', {
                  date: moment(get(event, 'startDate')).isValid()
                    ? moment(get(event, 'startDate')).format('LLL')
                    : null
                })}
              </span>
            </Tooltip>
          )}

          {/* Date de fin de l'Ã©vÃ©nement */}
          {get(event, 'eventType') !== 'COMMENT' &&
            moment(get(event, 'endDate')).isValid() && (
              <Tooltip
                placement='right'
                title={moment(get(event, 'endDate')).calendar()}
              >
                <span className='scenario-events-timeline-item-date scenario-events-timeline-item-date-ended'>
                  {I18n.t('pages.scenario.tabs.events.dates.end', {
                    date: moment(get(event, 'endDate')).isValid()
                      ? moment(get(event, 'endDate')).format('LLL')
                      : null
                  })}
                </span>
              </Tooltip>
            )}
        </p>

        {/* Boutons */}
        {isNil(get(scenario, 'endDate')) && (
          <div className='scenario-events-timeline-item-buttons buttons'>
            {/* Modifier */}
            <Button icon='form' onClick={() => this.askUpdateEvent(event)}>
              {I18n.t('pages.scenario.tabs.events.actions.update')}
            </Button>

            {/* Supprimer */}
            <Button
              icon='delete'
              type='danger'
              disabled={isLoading}
              onClick={() => this.askDeleteEvent(event)}
            >
              {I18n.t('pages.scenario.tabs.events.actions.delete')}
            </Button>
          </div>
        )}
      </Timeline.Item>
    )
  }

  /**
   * Rendu de la timeline des Ã©vÃ©nements
   */
  renderTimeline = () => {
    const { scenario } = this.props

    const eventsComments = orderBy(
      [
        ...defaultTo(get(scenario, 'events'), []),
        ...defaultTo(get(scenario, 'comments'), [])
      ],
      'startDate',
      'desc'
    )

    return isEmpty(eventsComments) ? (
      <Empty />
    ) : (
      <Timeline className='scenario-events-timeline'>
        {map(eventsComments, this.renderEvent)}
      </Timeline>
    )
  }

  render() {
    const { loading, title } = this.props

    return (
      <Card title={title} loading={loading} className='tab events'>
        {/* Timeline */}
        {this.renderTimeline()}
      </Card>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(EventsTab, 'defaultProps', {})

  return {
    scenario: defaultTo(get(state, 'scenario.item'), defaultProps.scenario),
    isGathering:
      defaultTo(get(state, 'event.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'event.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'event.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...eventActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsTab)
